
import { defineComponent } from 'vue'
import { NIcon } from 'naive-ui'
import {
  HourglassOutline,
  ArrowRedo,
  CheckmarkOutline,
} from '@vicons/ionicons5'
import CopyHash from '@/components/CopyHash.vue'
import { getNetworkByDomainID } from '@/utils'
import { IndexerTx } from '@/utils/nomadAPI'

export default defineComponent({
  props: {
    tx: {
      type: Object as () => IndexerTx,
      required: true,
    },
  },
  components: {
    NIcon,
    CopyHash,
    HourglassOutline,
    ArrowRedo,
    CheckmarkOutline,
  },
  computed: {
    manualProcess() {
      const dest = getNetworkByDomainID(this.tx.destination!)
      return dest.manualProcessing
    },
  },
})
